import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from 'src/app/common/constants';
@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private keyId = 'rzp_test_7KLp2owpp8pBGc';
  private keySecret = 'E0Xes4BpvL5W4MHOME3cWbgp';
  private backendUrl = Constants.baseUrl;
  private apiUrl = Constants.baseUrl+'/api/payment';

  constructor(private http: HttpClient) {}
 
 
 
  savePaymentDetails(paymentDetails: any): Observable<any> {
    return this.http.post(this.backendUrl, paymentDetails, { headers: { 'Content-Type': 'application/json' } });
  }
 
  createOrder(amount: number, receipt: string): Observable<any> {
    const payload = {
      amount: amount,  // Use the correct parameter for the amount
      receipt: receipt  // The receipt reference
    };
 
    // Send POST request to the backend to create an order
    return this.http.post<any>(`${this.apiUrl}/create-order`, payload);  // Adjust the endpoint to `/create-order`
  }
 
  // Method to verify payment
  verifyPayment(paymentId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Add any additional headers if needed, like Authorization
    });
 
    // Concatenate paymentId to the API URL
    return this.http.get(`${this.apiUrl}/verifypayment/${paymentId}`, { headers });
  }
}
 
 
 